export default "__VITE_ASSET__8407a6f8__"